<template>
  <div class="gcfp-container" v-loading.fullscreen.lock="fullscreenLoading">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.type" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌">
              <el-select v-model="searchForm.brandId" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option v-for="brand in brandList" :key="brand.brand_id" :label="brand.brand_name" :value="brand.brand_id" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item v-if="user.dGroupid===1 || user.dGroupid===2" style="float: right">
              <el-button-group>
                <el-button :type="mark===0?'primary':''" size="small" @click="changeMark(0)">未分派</el-button>
                <el-button :type="mark===1?'primary':''" size="small" @click="changeMark(1)">已分派</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>
          <div class="card-content" >
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="140"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="预付款时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.subsist_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="已分派工厂"
                    width="160"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.factory_name!==null&&scope.row.factory_name!==''">{{scope.row.factory_name}}</span>
                      <span style="color:#99a9bf" v-if="scope.row.factory_name===null||scope.row.factory_name===''">未分派</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="120"
                    align="center"
                    fixed="right"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===0" type="warning">待分派</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===1" type="success">待接单</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===2" type="danger">工厂拒接</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="mark===1">已分派</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="240"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-guide" v-if="scope.row.type===0" @click.stop="send(scope.row)">立即分派</el-button>
                      <el-button size="mini" icon="el-icon-guide" v-if="scope.row.type===1 && scope.row.ismultifactory===0 && user.dGroupid!==1 && user.dGroupid!==2" @click.stop="send(scope.row)">外协分派</el-button>
                      <el-button size="mini" icon="el-icon-guide" v-if="scope.row.type===2" :disabled="user.dGroupid!==1 && user.dGroupid!==2" @click.stop="send(scope.row)">重新分派</el-button>
                      <el-button size="mini" icon="el-icon-guide" v-if="scope.row.type===3" @click.stop="reSend(scope.row)">重新分派</el-button>
                      <el-button size="mini" icon="el-icon-refresh-left" type="danger" v-if="scope.row.type===1 && (user.dGroupid===1 || user.dGroupid===2)" @click.stop="undo(scope.row)" plain>撤销分派</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="editForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="接单详情" prop="detail" v-if="editForm.factoryname!==null&&editForm.factoryname!==''&&editForm.factoryname!==undefined">
          <el-card shadow="hover" style="font-size: 12px;color:#606266">
            <div>
              <span style="color:#99a9bf">接单人员：</span>
              <span>{{editForm.factoryname}}</span>
              <span style="color:#99a9bf;margin-left: 20px">接单时间：</span>
              <span>{{editForm.factory_time}}</span>
            </div>
            <div>
              <span style="color:#99a9bf">拒接原因：</span>
              <span>{{editForm.factory_rson}}</span>
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="分派工厂" prop="groupid">
          <el-select v-model="editForm.groupid" style="width:100%" multiple filterable clearable @remove-tag="removeTag" placeholder="请选择" @change="isMultiple" @clear="clearTag">
            <el-option
              v-for="item in groupList"
              v-if="item.brand===0||(editForm.productnum.indexOf('SZ')>=0&&item.brand===2)||(editForm.productnum.indexOf('SZ')<0&&item.brand===1)"
              :key="item.factory_id"
              :label="item.factory_name"
              :value="item.factory_id"
              :disabled="editForm.groupid && editForm.groupid.length>=3 && editForm.groupid.indexOf(item.factory_id) === -1 || item.factory_id === user.dGroupid">
              <span style="float: left">{{ item.factory_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.simple_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isMultiFactory" label="生产金额" prop="price">
          <el-input :readonly="true" placeholder="请打开报价明细计算" v-model="editForm.price">
            <template slot="prepend"><span @click="openMater" style="cursor: pointer;color:#409eff;font-weight: bold;"><i class="el-icon-document"></i> 点击查看报价明细</span></template>
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <!-- <div v-for="(item, index) in editForm.process" :key="item.key">
          <el-form-item :label="item.process_name" :prop="'process.' + index +'.process_name'" :rules="{required: true, message: '请选择日期', trigger: 'change'}">
            <div style="position: absolute">
              <i class="el-icon-remove-outline" style="color:#99a9bf" v-if="item.isComplete===0&&editForm.mark===12"></i>
              <i class="el-icon-time" style="color:#E6A23C" v-if="item.isComplete===0&&editForm.mark===13"></i>
              <i class="el-icon-success" style="color:#67C23A" v-if="item.isComplete===1"></i>
            </div>
            <el-date-picker
              @change="changePMCplanned"
              v-model="item.time"
              type="date"
              format="yyyy年MM月dd日"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </div> -->
        <el-form-item label="计划交期" prop="PMCplanned">
          <el-date-picker
            :disabled="false"
            v-model="editForm.PMCplanned"
            type="date"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <template v-if="!isMultiFactory">
          <el-form-item v-if="!isMultiFactory" label="色板信息" prop="swatch">
            <el-input v-model="editForm.swatch" type="textarea" maxlength="100" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="分派备注" prop="content">
            <el-input type="textarea" v-model="editForm.content" maxlength="200" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="附属文件" prop="files">
            <MultiFile v-model="editForm.files"></MultiFile>
          </el-form-item>
          <el-form-item label="附属图片" prop="imgids">
            <MultiImg v-model="editForm.imgids" :size="'sm'"></MultiImg>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="多工厂操作" prop="multigroupid">
            <el-collapse v-for="(factory,index) in editForm.multiFactory" :key="index">
              <el-collapse-item :title="factoryNames[index]" :name="index"> <!-- name为groupid的值 -->
                <el-form-item label="生产金额" :prop="factory.price" :rules="{ required: true, message: '请选择报价明细汇总生产金额', trigger: 'blur' }">
                  <el-input :readonly="true" placeholder="请勾选生产部件" v-model="factory.price">
                    <template slot="prepend"><span @click="openMater(index)" style="cursor: pointer;color:#409eff;font-weight: bold;"><i class="el-icon-document"></i> 点击勾选生产部件</span></template>
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="色板信息" :prop="factory.swatch" :rules="{ required: true, trigger: 'blur' }">
                  <el-input v-model="factory.swatch" type="textarea" maxlength="100" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="分派备注">
                  <el-input type="textarea" v-model="factory.content" maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="附属文件">
                  <MultiFile v-model="factory.files"></MultiFile>
                </el-form-item>
                <el-form-item label="附属图片">
                  <MultiImg v-model="factory.imgids" :size="'sm'"></MultiImg>
                </el-form-item>
              </el-collapse-item>
            </el-collapse>
          </el-form-item>
        </template>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')" :disabled="editForm.status ===11 && !isMultiFactory">立即分派</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="重新分派"
      :visible.sync="reSendDialog"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="reSendForm" :model="reSendForm" :rules="reSendRules" label-position="right" label-width="90px" size="small">
        <el-form-item label="操作订单" prop="ordername">
          <el-input v-model="reSendForm.ordername" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="分派工厂" prop="groupid">
          <el-select v-model="reSendForm.groupid" style="width:100%" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in groupList"
              v-if="item.brand===0||(reSendForm.productnum.indexOf('SZ')>=0&&item.brand===2)||(reSendForm.productnum.indexOf('SZ')<0&&item.brand===1)"
              :key="item.factory_id"
              :label="item.factory_name"
              :value="item.factory_id">
              <span style="float: left">{{ item.factory_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ item.simple_name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subReEdit('reSendForm')">立即分派</el-button>
          <el-button @click="reSendDialog=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      :title="tableDataList.materialTitle"
      :visible.sync="tableDataList.materialVisible"
      width="80%"
      top="10vh"
      v-loading="tableDataList.materialLoading"
      :destroy-on-close="true"
      :lock-scroll="true"
      :before-close="closeMaterial"
      :append-to-body="true"
      :key="materialShow"
      >
      <div style="width: 100%;position: relative;line-height: 32px;margin-bottom: 10px">
        <span class="tcf-title">其他费用：</span><span class="tcf-amount">{{tableDataList.otherAmount}}</span>
        <span class="tcf-title">部件费用：</span><span class="tcf-amount">{{tableDataList.materialAmount}}</span>
        <span class="tcf-title">费用总计：</span><span class="tcf-amount">{{ tableDataList.proamount }}</span>
        <el-button v-if="!isMultiFactory" icon="el-icon-refresh" @click="refProductOffer" size="mini" style="float: right" type="primary">重新计算</el-button>
      </div>
      <div style="width: 100%;margin-bottom: 20px">
        <el-table
          ref="otherMultipleTable"
          :data="tableDataList.otherTableData"
          border
          style="width: 100%"
          @selection-change="otherHandleSelectionChange"
          :key="materialShow">
          <el-table-column
            v-if="isMultiFactory"
            type="selection"
            :selectable="otherCheckBox"
            align="center"
            fixed
            width="55">
          </el-table-column>
          <el-table-column
            label="其他费用说明"
            min-width="180"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===1" type="warning">木架</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===2" type="success">调色</el-tag>
              <el-tag :disable-transitions="true" size="mini" v-if="scope.row.type===3" type="success">水性漆</el-tag>
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.dGroupid===1 || user.dGroupid===2"
            prop="amount"
            label="金额"
            width="140"
            align="center"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            v-if="user.dGroupid===1 || user.dGroupid===2"
            label="生产折扣"
            align="center"
            width="140">
            <template slot-scope="scope">
              <el-input v-model="scope.row.prodis" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')" @keyup.native="checkOtherDiscount(scope.row)" @blur="inputOtherOut(scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.dGroupid===1 || user.dGroupid===2"
            prop="proamount"
            label="生产金额"
            align="center"
            width="140"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            v-else
            prop="proamount"
            label="金额"
            align="center"
            width="140"
            show-overflow-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="isMultiFactory" style="width:100%;margin-bottom: 15px;color:#F56C6C;font-size: 13px">
<!--        <i class="el-icon-info"></i> 筛选功能未正确显示时请多点击几次！<br/>-->
        <i class="el-icon-info"></i> 勾选后请点击立即保存 <br/>
      </div>
      <div style="height: 520px;width: 100%;">
        <pl-table
          height="520px"
          :datas="tableDataList.materialTableData"
          :data="tableDataList.materialTableData"
          :key="materialShow"
          ref="multipleTable"
          border
          size="small"
          use-virtual
          :pagination-show="false"
          :row-height="45"
          @selection-change="handleSelectionChange"
        >
          <pl-table-column v-if="isMultiFactory" :selectable="checkBox" type="selection" align="center" fixed width="55"/>
          <pl-table-column prop="xuhao" label="序号" width="80" show-overflow-tooltip fixed />
          <pl-table-column v-if="isMultiFactory" prop="area" :filters="screens.area" :filter-method="filterArea" label="区域" width="120" show-overflow-tooltip />
          <pl-table-column v-if="isMultiFactory" prop="type" :filters="screens.type" :filter-method="filterType" label="分类" width="80" show-overflow-tooltip />
          <pl-table-column v-if="!isMultiFactory" prop="area" label="区域" width="120" show-overflow-tooltip />
          <pl-table-column v-if="!isMultiFactory" prop="type" label="分类" width="80" show-overflow-tooltip />
          <pl-table-column v-if="isMultiFactory" :filters="screens.name" :filter-method="filterName" prop="name" label="名称" width="160" show-overflow-tooltip />
          <pl-table-column v-if="!isMultiFactory" prop="name" label="名称" width="160" show-overflow-tooltip />
          <pl-table-column v-if="isMultiFactory" prop="material" :filters="screens.material" :filter-method="filterMaterial" label="基材" width="80" show-overflow-tooltip />
          <pl-table-column v-else prop="material" label="基材" width="80" show-overflow-tooltip />
          <pl-table-column prop="high" label="高/长" width="70" show-overflow-tooltip />
          <pl-table-column prop="width" label="宽" width="70" show-overflow-tooltip />
          <pl-table-column prop="lwidth" label="L宽" width="70" show-overflow-tooltip />
          <pl-table-column prop="ply" label="厚" width="70" show-overflow-tooltip />
          <pl-table-column prop="num" label="数量" width="70" show-overflow-tooltip />
          <pl-table-column prop="val" label="数值" width="70" show-overflow-tooltip />
          <pl-table-column prop="unit" label="单位" width="70" show-overflow-tooltip />
          <pl-table-column v-if="isMultiFactory" prop="color" label="颜色" width="140" :filters="screens.color" :filter-method="filterColor" show-overflow-tooltip />
          <pl-table-column v-else prop="color" label="颜色" width="140" show-overflow-tooltip />
          <pl-table-column v-if="isMultiFactory" :filters="screens.remark" :filter-method="filterRemark" prop="remark" label="备注" min-width="160" show-overflow-tooltip />
          <pl-table-column v-if="!isMultiFactory" prop="remark" label="备注" min-width="160" show-overflow-tooltip />
          <pl-table-column v-if="user.dGroupid===1 || user.dGroupid===2" prop="price" label="单价" align="center" width="100" show-overflow-tooltip fixed="right"/>
          <pl-table-column v-if="user.dGroupid===1 || user.dGroupid===2" prop="total" label="金额" align="center" width="100" show-overflow-tooltip fixed="right"/>
          <pl-table-column v-if="user.dGroupid===1 || user.dGroupid===2" label="生产折扣" align="center" width="100" show-overflow-tooltip fixed="right">
            <template slot-scope="scope">
              <el-input v-model="scope.row.prodis" size="mini" onkeyup="value=value.replace(/[^\d.]/g,'')" @keyup.native="checkDiscount(scope.row)" @blur="inputOut(scope.row)"></el-input>
            </template>
          </pl-table-column>
          <pl-table-column v-if="user.dGroupid===1 || user.dGroupid===2" prop="proamount" label="折后金额" align="center" width="100" show-overflow-tooltip fixed="right"/>
          <pl-table-column v-else prop="proamount" label="金额" align="center" width="100" show-overflow-tooltip fixed="right"/>
        </pl-table>
      </div>
<!--      <div slot="footer" class="dialog-footer">-->
<!--        <el-button size="small" @click="tableDataList.materialVisible=false">关闭</el-button>-->
<!--      </div>-->
      <div v-if="isMultiFactory" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editPreservation">立即保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import {
  getOrderProductList, getFactoryList, factoryAssign, undoFactoryAssign,
  editOrderFactoryAssign, orderProductOfferOper, editOrderProductOfferProdis, multiFactoryAssign
} from '@/api/erp'
import MultiFile from '@/components/upload/MultiFile'
import MultiImg from '@/components/upload/MultiImg'
import { getBrandList, getMaterialDataList } from '@/api/work'
import item from '@/layout/components/Sidebar/Item'

export default {
  name: 'gcfp',
  computed: {
    user: getUser
  },
  components: {
    MultiFile,
    MultiImg
  },
  data() {
    return {
      fullscreenLoading: false,
      loading: false,
      tableDataList: {
        totalCount: 0,
        materialAmount: 0,
        otherAmount: 0,
        proamount: 0,
        materialTableData: [],
        otherTableData: [],
        materialLoading: false,
        materialTitle: '',
        materialVisible: false
      },
      materialShow: '',
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      groupList: [],
      editVisible: false,
      editloading: false,
      orderid: '',
      editForm: {
        orderid: '',
        ordername: '',
        productnum: '',
        groupid: [],
        content: '',
        files: [],
        imgids: [],
        factory_rson: '',
        factoryname: '',
        factory_time: '',
        price: null,
        discount: null,
        process: [],
        swatch: '',
        PMCplanned: null,
        status: 0, // 记录订单状态
        multiFactory: [{
          id: null,
          price: null,
          swatch: '',
          content: '',
          files: [],
          imgids: [],
          multipleSelection: [],
          mdid: [],
          otherMultipleSelection: [],
          ooid: []
        }]
      },
      editRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        groupid: [{ required: true, message: '请选择分派的工厂', trigger: 'change' }],
        price: [{ required: true, message: '请选择报价明细汇总生产金额', trigger: 'blur' }],
        swatch: [{ required: true, message: '请输入色板信息', trigger: 'blur' }]
      },
      searchForm: {
        search: '',
        type: '',
        brandId: ''
      },
      brandList: [],
      mark: 0,
      reSendDialog: false,
      reSendForm: {
        ordername: '',
        groupid: '',
        productnum: '',
        orderid: ''
      },
      reSendRules: {
        ordername: [{ required: true, message: '请选择订单', trigger: 'blur' }],
        groupid: [{ required: true, message: '请选择分派的工厂', trigger: 'change' }]
      },
      dialogTitle: '工厂分派',
      isMultiFactory: false,
      factoryNames: [],
      openIndex: 0, // 存储当前打开的是第几个工厂
      showMultiFactory: '', // 重复生成相同组件key值区分
      temporarySelect: [],
      temporaryOtherSelect: [],
      completeSelect: [], // 已选择部分
      completeOtherSelect: [],
      screens: {
        type: [],
        area: [],
        name: [],
        color: [],
        material: [],
        remark: []
      },
      tagflag: false // tag是否正在移除,未用到
    }
  },
  created() {
    this.getData()
    getFactoryList().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    this.getBrandList()
  },
  methods: {
    clearTag() {
      if (this.editForm.groupid.length === 0 && this.user.dGroupid !== 1 && this.user.dGroupid !== 2) {
        this.editForm.groupid.push(this.user.dGroupid)
        this.isMultiple()
      }
    },
    async removeTag(item) {
      if (item === this.user.dGroupid) {
        this.editForm.groupid.unshift(item)
        this.isMultiple()
      }
    },
    // changePMCplanned() {
    //   let temp
    //   for (let i = 0; i < this.editForm.process.length; i++) {
    //     if (this.editForm.process[i].time !== null && this.editForm.process[i].time !== '' && this.editForm.process[i].time !== undefined) {
    //       temp = this.editForm.process[i].time
    //       break
    //     }
    //   }
    //   for (let i = 0; i < this.editForm.process.length; i++) {
    //     const olded = new Date(Date.parse(temp))
    //     const ed = new Date(Date.parse(this.editForm.process[i].time))
    //     if (ed > olded) {
    //       temp = this.editForm.process[i].time
    //     }
    //   }
    //   this.editForm.PMCplanned = temp
    // },
    changeMark(val) {
      this.mark = val
      this.getData()
    },
    getBrandList() {
      getBrandList().then(response => {
        this.brandList = response.data
      })
    },
    Search() {
      this.currentPage = 1
      this.searchForm.search = this.searchForm.search.trim()
      this.getData()
    },
    getData() {
      this.materialShow = new Date().getTime().toString()
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        mark: '10,11',
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        type: this.searchForm.type,
        brandId: this.searchForm.brandId,
        assign: this.mark
      }
      getOrderProductList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        console.log(this.tableData)
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (row.type === 2 && row.ismultifactory === 0 && this.user.dGroupid !== 1 && this.user.dGroupid !== 2) {
        return
      }
      this.$router.push({
        path: '/work/order/' + row.order_id,
        query: {
          data: row.factoryid
        }
      })
    },
    reSend(row) {
      this.reSendForm.orderid = row.order_id
      this.reSendForm.ordername = row.order_num + '/' + row.product_num + '/' + row.address
      this.reSendForm.productnum = row.product_num
      this.reSendForm.groupid = row.factory_id
      this.reSendDialog = true
    },
    subReEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const data = {
            orderid: this.reSendForm.orderid,
            userid: this.user.dUserid,
            fatoryid: this.reSendForm.groupid
          }
          editOrderFactoryAssign(data).then(response => {
            this.$message({
              message: '订单工厂已重新分派成功',
              type: 'success'
            })
            this.reSendDialog = false
            this.getData()
          })
        }
      })
    },
    send(row) {
      this.tableDataList.proamount = 0
      this.tableDataList.totalCount = 0
      this.tableDataList.materialAmount = 0
      this.tableDataList.otherAmount = 0
      this.orderid = row.order_id
      this.editForm.orderid = row.order_id
      this.tableDataList.materialTitle = row.product_num + ' 生产报价明细'
      this.editForm.productnum = row.product_num
      this.editForm.ordername = row.order_num + ' / ' + row.product_num + ' / ' + row.address
      this.editForm.content = ''
      this.editForm.files = []
      this.editForm.imgids = []
      this.editForm.factory_rson = row.factory_rson
      this.editForm.factoryname = row.factoryname
      this.editForm.factory_time = row.factory_time
      this.editForm.price = null
      this.editForm.discount = null
      this.editForm.swatch = ''
      this.editForm.PMCplanned = null
      this.editForm.status = row.status
      if (row.factory_id !== null && row.factory_id !== '' && row.factory_id !== undefined && row.factory_id !== 0) {
        this.editForm.groupid = []
        this.editForm.groupid.push(row.factory_id)
      } else {
        this.editForm.groupid = []
      }
      this.editForm.multiFactory = []
      this.isMultiFactory = false
      this.getMaterialDetail()
      this.editVisible = true
    },
    undo(row) {
      this.$confirm('此操作将撤销此次的工厂分派, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = true
        undoFactoryAssign({ userid: this.user.dUserid, orderid: row.order_id, groupid: this.user.dGroupid }).then(response => {
          this.$message({
            message: '订单工厂分派已撤销',
            type: 'success'
          })
          this.fullscreenLoading = false
          this.getData()
        }).catch(() => {
          this.fullscreenLoading = false
        })
      }).catch(() => {})
    },
    subEdit(formName) {
      if (!this.isMultiFactory) {
        console.log('a--')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // for (let p of this.editForm.process) {
            //   if (p.time === '' || p.time === null || p.time === undefined) {
            //     this.$message.error('必填信息不能为空！！！')
            //     return false
            //   }
            // }
            this.SubSendOrder()
          } else {
            return false
          }
        })
      } else {
        console.log('b--')
        if (!(this.completeSelect.length === this.tableDataList.materialTableData.length &&
        this.completeOtherSelect.length === this.tableDataList.otherTableData.length)) {
          // console.log(this.completeSelect.length)
          // console.log(this.tableDataList.materialTableData.length)
          // console.log(this.completeOtherSelect.length)
          // console.log(this.tableDataList.otherTableData.length)
          this.$message.error('还有部件未被选择,请重新选择!!!')
          return false
        } else {
          for (let i = 0; i < this.editForm.multiFactory.length; i++) {
            if (this.editForm.multiFactory[i].multipleSelection.length + this.editForm.multiFactory[i].otherMultipleSelection.length === 0) {
              this.$message.error("未有部件分配给 '" + this.factoryNames[i] + "' ,请查看内容是否出错!")
              return false
            }
          }
          // 部件分配都没问题了开始下一步
          // for (const p of this.editForm.process) {
          //   if (p.time === '' || p.time === null || p.time === undefined) {
          //     this.$message.error('必填信息不能为空！！！')
          //     return false
          //   }
          // }
          for (const item of this.editForm.multiFactory) {
            console.log('c--')
            // console.log(item)
            if (item.swatch === '') {
              this.$message.error('色板信息不能为空！！！')
              return false
            }
          }
          this.SubSendOrder()
        }
      }
    },
    SubSendOrder() {
      if (!this.editloading) {
        this.editloading = true
        let jsonStr = ''
        // for (let p of this.editForm.process) {
        //   jsonStr += '"' + p.process_id + '":' + '"' + p.time + '"' + ','
        // }
        // if (jsonStr.length > 0) {
        //   jsonStr = '{' + jsonStr.substring(0, jsonStr.length - 1) + '}'
        // }
        if (!this.isMultiFactory) {
          console.log('d--')
          const data = {
            userid: this.user.dUserid,
            orderid: this.editForm.orderid,
            factoryid: this.editForm.groupid[0],
            content: this.editForm.content,
            fileStr: this.editForm.files.join(','),
            imgStr: this.editForm.imgids.join(','),
            // discount: this.editForm.discount,
            price: this.editForm.price,
            PMCplanned: this.editForm.PMCplanned,
            jsonStr: jsonStr,
            colorinfo: this.editForm.swatch
          }
          factoryAssign(data).then(response => {
            this.$message({
              message: '订单工厂已分派成功',
              type: 'success'
            })
            this.editloading = false
            this.editVisible = false
            this.getData()
          }).catch(() => {
            this.editloading = false
          })
        } else { // 多工厂
          if (this.editForm.status === 11) { // 工厂进行多分派时需要先将状态通过撤回改为10
            // 先撤销
            this.fullscreenLoading = true
            undoFactoryAssign({
              userid: 'wx',
              orderid: this.editForm.orderid,
              groupid: this.user.dGroupid
            }).then(response => {
              // this.$message({
              //   message: '订单工厂分派已撤销',
              //   type: 'success'
              // })
              this.fullscreenLoading = false
              // 储存多项数据，转为json格式 {"a": "111"}
              let priceJson = ''
              let swatchJson = ''
              let contentJson = ''
              let fileStrJson = ''
              let imgStrJson = ''
              // TODO 想办法将需要传值的内容通过json给到后台
              let multipleJson = ''
              let othermultipleJson = ''
              this.editForm.multiFactory.forEach((item, index) => {
                priceJson += '"price' + index + '": "' + item.price + '",'
                swatchJson += '"swatch' + index + '": "' + item.swatch + '",'
                contentJson += '"content' + index + '": "' + item.content + '",'
                fileStrJson += '"files' + index + '": "' + item.files.join(',') + '",'
                imgStrJson += '"imgids' + index + '": "' + item.imgids.join(',') + '",'
                multipleJson += '"multiple' + index + '": "' + item.mdid.join(',') + '",'
                othermultipleJson += '"othermultiple' + index + '": "' + item.ooid.join(',') + '",'
              })
              priceJson = '{' + priceJson.substring(0, priceJson.length - 1) + '}'
              swatchJson = '{' + swatchJson.substring(0, swatchJson.length - 1) + '}'
              contentJson = '{' + contentJson.substring(0, contentJson.length - 1) + '}'
              fileStrJson = '{' + fileStrJson.substring(0, fileStrJson.length - 1) + '}'
              imgStrJson = '{' + imgStrJson.substring(0, imgStrJson.length - 1) + '}'
              multipleJson = '{' + multipleJson.substring(0, multipleJson.length - 1) + '}'
              othermultipleJson = '{' + othermultipleJson.substring(0, othermultipleJson.length - 1) + '}'
              const data = {
                userid: this.user.dUserid,
                orderid: this.editForm.orderid,
                factoryid: this.editForm.groupid.join(','),
                PMCplanned: this.editForm.PMCplanned,
                jsonStr: jsonStr,
                priceJson: priceJson,
                swatchJson: swatchJson,
                contentJson: contentJson,
                fileStrJson: fileStrJson,
                imgStrJson: imgStrJson,
                multipleJson: multipleJson,
                othermultipleJson: othermultipleJson
              }
              // 再分派
              multiFactoryAssign(data).then(response => {
                this.$message({
                  message: '订单分派多工厂已成功',
                  type: 'success'
                })
                this.editloading = false
                this.editVisible = false
                this.isMultiFactory = false
                this.getData()
              }).catch(() => {
                this.editloading = false
              })
            }).catch(() => {
              this.fullscreenLoading = false
            })
          } else {
            // 储存多项数据，转为json格式 {"a": "111"}
            let priceJson = ''
            let swatchJson = ''
            let contentJson = ''
            let fileStrJson = ''
            let imgStrJson = ''
            // TODO 想办法将需要传值的内容通过json给到后台
            let multipleJson = ''
            let othermultipleJson = ''
            this.editForm.multiFactory.forEach((item, index) => {
              priceJson += '"price' + index + '": "' + item.price + '",'
              swatchJson += '"swatch' + index + '": "' + item.swatch + '",'
              contentJson += '"content' + index + '": "' + item.content + '",'
              fileStrJson += '"files' + index + '": "' + item.files.join(',') + '",'
              imgStrJson += '"imgids' + index + '": "' + item.imgids.join(',') + '",'
              multipleJson += '"multiple' + index + '": "' + item.mdid.join(',') + '",'
              othermultipleJson += '"othermultiple' + index + '": "' + item.ooid.join(',') + '",'
            })
            priceJson = '{' + priceJson.substring(0, priceJson.length - 1) + '}'
            swatchJson = '{' + swatchJson.substring(0, swatchJson.length - 1) + '}'
            contentJson = '{' + contentJson.substring(0, contentJson.length - 1) + '}'
            fileStrJson = '{' + fileStrJson.substring(0, fileStrJson.length - 1) + '}'
            imgStrJson = '{' + imgStrJson.substring(0, imgStrJson.length - 1) + '}'
            multipleJson = '{' + multipleJson.substring(0, multipleJson.length - 1) + '}'
            othermultipleJson = '{' + othermultipleJson.substring(0, othermultipleJson.length - 1) + '}'
            const data = {
              userid: this.user.dUserid,
              orderid: this.editForm.orderid,
              factoryid: this.editForm.groupid.join(','),
              PMCplanned: this.editForm.PMCplanned,
              jsonStr: jsonStr,
              priceJson: priceJson,
              swatchJson: swatchJson,
              contentJson: contentJson,
              fileStrJson: fileStrJson,
              imgStrJson: imgStrJson,
              multipleJson: multipleJson,
              othermultipleJson: othermultipleJson
            }
            multiFactoryAssign(data).then(response => {
              this.$message({
                message: '订单分派多工厂已成功',
                type: 'success'
              })
              this.editloading = false
              this.editVisible = false
              this.isMultiFactory = false
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          }
        }
      } else {
        return false
      }
    },
    openMater(index) {
      this.materialShow = new Date().getTime().toString()
      // 赋值 0
      if (index) {
        this.openIndex = index
        console.log(this.openIndex)
      } else {
        this.openIndex = 0
        console.log(this.openIndex)
      }
      // 多选框默认值
      if (this.isMultiFactory) {
        this.temporarySelect = this.editForm.multiFactory[this.openIndex].multipleSelection
        this.temporaryOtherSelect = this.editForm.multiFactory[this.openIndex].otherMultipleSelection
        if (this.editForm.multiFactory[this.openIndex].otherMultipleSelection.length > 0) {
          console.log(this.editForm.multiFactory[this.openIndex].otherMultipleSelection)
          this.$nextTick(() => {
            this.editForm.multiFactory[this.openIndex].otherMultipleSelection.forEach(row => {
              this.$refs.otherMultipleTable.toggleRowSelection(
                this.tableDataList.otherTableData.find((item) => {
                  return row.id === item.id
                }),
                true)
            })
          })
        }
        if (this.editForm.multiFactory[this.openIndex].multipleSelection.length > 0) {
          console.log('111: ' + this.editForm.multiFactory[this.openIndex].multipleSelection)
          const arr = []
          this.$nextTick(() => {
            this.editForm.multiFactory[this.openIndex].multipleSelection.forEach(row => {
              arr.push({
                row: this.tableDataList.materialTableData.find((item) => {
                  return row.mdid === item.mdid
                })
              })
            })
            this.$refs.multipleTable.toggleRowSelection(arr)
            console.log(arr)
          })
        }
      }
      this.tableDataList.materialVisible = true
    },
    refAmount() {
      let amount = 0
      for (const materialData of this.tableDataList.materialTableData) {
        amount += parseFloat(materialData.proamount)
      }
      this.tableDataList.materialAmount = amount.toFixed(2)
      let oamount = 0
      for (const o of this.tableDataList.otherTableData) {
        amount += parseFloat(o.proamount)
        oamount += parseFloat(o.proamount)
      }
      this.tableDataList.otherAmount = oamount.toFixed(2)
      this.tableDataList.proamount = amount.toFixed(2)
      if (this.tableDataList.proamount >= 0) {
        this.editForm.price = this.tableDataList.proamount
      } else {
        this.editForm.price = null
      }
    },
    inputOtherOut(row) {
      let zk = parseFloat(row.prodis)
      if (zk === null || zk === undefined || isNaN(zk)) {
        zk = 0
      }
      if (zk < 0 || zk > 10) {
        zk = 0
      }
      const data = {
        type: 0,
        id: row.id,
        prodis: zk,
        proamount: row.proamount
      }
      editOrderProductOfferProdis(data)
    },
    inputOut(row) {
      let zk = parseFloat(row.prodis)
      if (zk === null || zk === undefined || isNaN(zk)) {
        zk = 0
      }
      if (zk < 0 || zk > 10) {
        zk = 0
      }
      const data = {
        type: 1,
        id: row.mdid,
        prodis: zk,
        proamount: row.proamount
      }
      editOrderProductOfferProdis(data)
    },
    checkOtherDiscount(row) {
      for (let o of this.tableDataList.otherTableData) {
        if (o.id === row.id) {
          let zk = parseFloat(row.prodis)
          if (zk === null || zk === undefined || isNaN(zk)) {
            zk = 0
          }
          if (zk < 0 || zk > 10) {
            this.$message.error('请输入正确的（0-10之间）折扣')
            zk = 0
          }
          let amount = o.amount
          if (zk >= 0) {
            amount = zk / 10 * o.amount
          }
          o.proamount = amount.toFixed(2)
          this.refAmount()
          break
        }
      }
    },
    checkDiscount(row) {
      for (let o of this.tableDataList.materialTableData) {
        if (o.mdid === row.mdid) {
          let zk = parseFloat(row.prodis)
          if (zk === null || zk === undefined || isNaN(zk)) {
            zk = 0
          }
          if (zk < 0 || zk > 10) {
            this.$message.error('请输入正确的（0-10之间）折扣')
            zk = 0
          }
          let amount = o.total
          if (zk >= 0) {
            amount = zk / 10 * o.total
          }
          o.proamount = amount.toFixed(2)
          this.refAmount()
          break
        }
      }
    },
    getMaterialDetail() {
      this.tableDataList.materialTableData = []
      this.tableDataList.otherTableData = []
      this.tableDataList.materialLoading = true
      getMaterialDataList({ orderid: this.orderid }).then(response => {
        this.editForm.process = response.data.processlst
        this.tableDataList.materialTableData = response.data.mlst
        // 处理数据以作筛选
        const setArea = new Set()
        const setType = new Set()
        const setName = new Set()
        const setColor = new Set()
        const setMaterial = new Set()
        const setRemark = new Set()
        this.tableDataList.materialTableData.forEach(item => {
          setArea.add(item.area)
          setType.add(item.type)
          setName.add(item.name)
          setColor.add(item.color)
          setMaterial.add(item.material)
          setRemark.add(item.remark)
        })
        const objArea = []
        const objType = []
        const objName = []
        const objColor = []
        const objMaterial = []
        const objRemark = []
        setArea.forEach(item => {
          objArea.push({
            text: item,
            value: item
          })
        })
        setType.forEach(item => {
          objType.push({
            text: item,
            value: item
          })
        })
        setName.forEach(item => {
          objName.push({
            text: item,
            value: item
          })
        })
        setColor.forEach(item => {
          objColor.push({
            text: item,
            value: item
          })
        })
        setMaterial.forEach(item => {
          objMaterial.push({
            text: item,
            value: item
          })
        })
        setRemark.forEach(item => {
          objRemark.push({
            text: item,
            value: item
          })
        })
        this.screens.area = objArea
        this.screens.type = objType
        this.screens.name = objName
        this.screens.color = objColor
        this.screens.material = objMaterial
        this.screens.remark = objRemark
        let amount = 0
        let count = 0
        for (const materialData of this.tableDataList.materialTableData) {
          amount += parseFloat(materialData.proamount)
          count += parseInt(materialData.num)
        }
        this.tableDataList.materialAmount = amount.toFixed(2)
        this.tableDataList.otherTableData = response.data.otherlst
        let oamount = 0
        for (const o of this.tableDataList.otherTableData) {
          amount += parseFloat(o.proamount)
          oamount += parseFloat(o.proamount)
        }
        this.tableDataList.otherAmount = oamount.toFixed(2)
        this.tableDataList.proamount = amount.toFixed(2)
        if (this.tableDataList.proamount >= 0) {
          this.editForm.price = this.tableDataList.proamount
        } else {
          this.editForm.price = null
        }
        this.tableDataList.totalCount = count
        this.tableDataList.materialLoading = false
      }).catch(() => {
        this.tableDataList.materialLoading = false
      })
    },
    refProductOffer() {
      this.$confirm('此操作将重新计算订单生产折扣金额, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.tableDataList.materialLoading = true
        orderProductOfferOper({ orderid: this.orderid }).then(response => {
          this.getMaterialDetail()
        }).catch(() => {
          this.tableDataList.materialLoading = false
        })
      }).catch(() => {})
    },
    closeMaterial() {
      if (this.isMultiFactory) {
        this.sumTotal()
      }
      this.tableDataList.materialVisible = false
    },
    // 判断是否选择了多工厂
    isMultiple() {
      if (this.editForm.groupid.length > 1) {
        this.showMultiFactory = new Date().getTime().toString()
        this.dialogTitle = '多工厂分派'
        this.isMultiFactory = true
        this.completeSelect = []
        this.completeOtherSelect = []
        const factoryArr = []
        this.editForm.groupid.forEach((id) => {
          console.log(id)
          factoryArr.push({
            id: id,
            price: null,
            swatch: '',
            content: '',
            files: [],
            imgids: [],
            multipleSelection: [],
            mdid: [],
            otherMultipleSelection: [],
            ooid: []
          })
        })
        this.editForm.multiFactory = factoryArr
      } else {
        this.dialogTitle = '工厂分派'
        this.isMultiFactory = false
        this.editForm.multiFactory = []
        // console.log(this.editForm.groupid)
      }
      if (this.editForm.groupid && this.editForm.groupid.length > 1) {
        this.getFactoryNames()
      }
    },
    getFactoryNames() {
      const arr = []
      this.editForm.groupid.forEach((id) => {
        this.groupList.some(function(item) {
          if (item.factory_id === id) {
            arr.push(item.factory_name)
          }
        })
      })
      this.factoryNames = arr
    },
    handleSelectionChange(val) {
      this.temporarySelect = val
    },
    otherHandleSelectionChange(val) {
      this.temporaryOtherSelect = val
    },
    // 点击保存
    editPreservation() {
      this.editForm.multiFactory[this.openIndex].multipleSelection = this.temporarySelect
      this.editForm.multiFactory[this.openIndex].otherMultipleSelection = this.temporaryOtherSelect
      const setSelect = new Set()
      const setOtherSelect = new Set()
      const mid = []
      this.editForm.multiFactory.forEach(selection => {
        selection.multipleSelection.forEach(item => {
          setSelect.add(item)
        })
      })
      this.editForm.multiFactory[this.openIndex].multipleSelection.forEach(item => {
        mid.push(item.mdid)
      })
      this.editForm.multiFactory[this.openIndex].mdid = [...mid]
      const oid = []
      this.editForm.multiFactory.forEach(selection => {
        selection.otherMultipleSelection.forEach(item => {
          setOtherSelect.add(item)
        })
      })
      this.editForm.multiFactory[this.openIndex].otherMultipleSelection.forEach(item => {
        oid.push(item.id)
      })
      this.editForm.multiFactory[this.openIndex].ooid = [...oid]
      this.editForm.multiFactory.forEach(item => {
        console.log('ooid---')
        console.log(item.ooid)
        console.log('mdid---')
        console.log(item.mdid)
      })
      this.completeSelect = [...setSelect]
      this.completeOtherSelect = [...setOtherSelect]
      console.log('1 --' + this.completeSelect)
      this.sumTotal()
      console.log('2 --' + this.completeOtherSelect)
      // TODO JSON传值参考
      console.log(JSON.parse(JSON.stringify(this.editForm.multiFactory[this.openIndex].multipleSelection)))
      this.tableDataList.materialVisible = false
    },
    sumTotal() {
      let totalMoney = 0
      this.editForm.multiFactory[this.openIndex].multipleSelection.forEach(item => {
        totalMoney += item.proamount * 1
      })
      this.editForm.multiFactory[this.openIndex].otherMultipleSelection.forEach(item => {
        totalMoney += item.proamount * 1
      })
      this.editForm.multiFactory[this.openIndex].price = totalMoney.toFixed(2) + ''
    },
    checkBox(row) {
      if (this.completeSelect.some(item => item === row)) {
        if (this.editForm.multiFactory[this.openIndex].multipleSelection.some(item => item === row)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    otherCheckBox(row) {
      if (this.completeOtherSelect.some(item => item === row)) {
        if (this.editForm.multiFactory[this.openIndex].otherMultipleSelection.some(item => item === row)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    filterArea(value, row) {
      return row.area === value
    },
    filterType(value, row) {
      return row.type === value
    },
    filterName(value, row) {
      return row.name === value
    },
    filterColor(value, row) {
      return row.color === value
    },
    filterMaterial(value, row) {
      return row.material === value
    },
    filterRemark(value, row) {
      return row.remark === value
    }
    /* getOrderPrice(val){
      if(val!=='' && val!==null) {
        getFactoryPrice({ orderid: this.editForm.orderid, factoryid: val }).then(response => {
          if (response.data !== null) {
            this.editForm.discount = response.data.factoryDiscount
            this.editForm.price = response.data.factoryAmount
          }
        })
      }else {
        this.editForm.discount = null
        this.editForm.price = null
      }
    } */
  }
}
</script>

<style lang="scss" scoped>
.gcfp-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
